<template>
  <section class="seccion">
    <h1 class="titulo">{{ nombre }}</h1>
    <slot />
  </section>
</template>

<script>
export default {
  props: {
    nombre: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 0.75rem;
}
.titulo {
  font-size: 1rem;
  color: #bbb;
}
.seccion {
  margin-bottom: 2rem;
}
</style>
